<template>
        <div class="background-image">

  <div class="mx-4 pt-5 pb-5">
    <Bar id="my-chart-id" class="bg-color" :options="chartOptions" :data="chartData" :height="chartHeight"/>
  </div>
  </div>
</template>

<script>
import { Bar } from "vue-chartjs";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
);

export default {
  name: "SolimanologResultados",
  components: { Bar },

  data() {
    return {
      //   chartData: {
      //     labels: [],
      cantidades: [],
      chartOptions: {
        // Agrega este objeto chartOptions
        responsive: true,
        indexAxis: "y",
        scales: {
          x: {
            beginAtZero: true,
          },

        },
        
      },
      chartHeight: "320px"

    };
  },
  created() {
    this.loadData();
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },

    chartData() {
      const arreglo = [];
      const cantidades = [];
      //  const labels = Object.values(this.estados);
      // const data = Object.values(this.estados);
      this.cantidades.map((r) => {
        arreglo.push(`GRUPO ${r.conGrupo}`);
    
        cantidades.push(r.cantidad);

      
      });

      const labels = arreglo;
      console.log(arreglo);
      const datasets = [
        {
          label: "TABLA DE PUNTAJES ", // Aquí defines el texto del título del conjunto de datos
        

          data: cantidades, // Aquí usamos el arreglo de cantidades
          backgroundColor: ["#FFFF","#4CAF50", "#FF6384", "#36A2EB", "#16FFED", "#FFBE04"],
        },
      ];
      return {
        labels,
        datasets,
      };
    },
  },

  mounted() {
    // Observa cambios en chartData y llama a loadData cuando cambia
  },

  methods: {
    loadData() {
      this.axios.get(`Webscraping/Resultados`).then((response) => {
        this.cantidades = response.data;
        console.log(this.cantidades);
        // const labels = response.data.map((r) => `Grupo ${r.conGrupo}`);
        // const data = response.data.map((r) => r.cantidad);

        // this.chartData.labels = labels;
        // this.chartData.datasets[0].data = data;
      });
    },
  },
};
</script>

<style scoped>
.background-image {
  background-image: url('@/assets/haloweenimg/halos.png');
  background-size: auto; /* Mantener el tamaño original de la imagen de fondo */
  background-repeat: repeat; 
  height: 100vh;

}

.bg-color{
  background: rgb(255, 200, 194);
}
</style>
